import { AxiosResponse } from "axios";
import {
  DeletePayload,
  PostPayload,
  PutPayload,
} from "../../../model/http-crud-models";
import { OrganizationKeyName } from "../../../model/Organization";
import {
  DeliveryProviderConfiguration,
  MutateDeliveryProviderConfigurationPayload,
} from "../models/delivery-provider-configuration";
import { httpClient } from "../../../service/http";

export const deliveryProviderConfigurationsHttp = {
  createDeliveryProviderConfiguration: ({
    organizationKeyName,
    data,
  }: PostPayload<MutateDeliveryProviderConfigurationPayload>): Promise<any> => {
    return httpClient({
      method: "POST",
      url: `/organizations/${organizationKeyName}/delivery-provider-configurations`,
      data,
    });
  },

  updateDeliveryProviderConfiguration: ({
    organizationKeyName,
    data: { id, ...rest },
  }: PutPayload<MutateDeliveryProviderConfigurationPayload>): Promise<AxiosResponse> => {
    return httpClient({
      method: "PUT",
      url: `/organizations/${organizationKeyName}/delivery-provider-configurations/${id}`,
      data: rest,
    });
  },

  getDeliveryProviderConfigurations: async (
    organizationKeyName: OrganizationKeyName
  ) => {
    const res = await httpClient<{ data: DeliveryProviderConfiguration[] }>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/delivery-provider-configurations`,
    });

    return res.data;
  },

  deleteDeliveryProviderConfiguration: async ({
    data: { id },
    organizationKeyName,
  }: DeletePayload) => {
    if (!id) return;

    return httpClient({
      method: "DELETE",
      url: `/organizations/${organizationKeyName}/delivery-provider-configurations/${id}`,
    });
  },
};
